import {
    FormControl,
    FormLabel,
    Stack,
    Text,
    VStack,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Input } from '@/components/v4';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
    textBoxStyling,
} from 'components/forms/new/formStyles';
import { useDefinedAttributes } from '../DefinedAttributesContext';
import useDefinedAttributeValidation from './useDefinedAttributeValidation';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import LinkifiedText from './LinkifiedText';
import { useState } from 'react';

// Matches OperatorConnectNameField pattern, but context controlled
export default function GuidAttribute({ attribute, index }) {
    const [isHovered, setIsHovered] = useState(false);
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { attributesErrors } = useDefinedAttributes();
    const error = attributesErrors.find((obj) => obj.id === index);
    const { handleAttributeChange, removeAttributeError } =
        useDefinedAttributeValidation();
    const handleChange = (e) => {
        removeAttributeError(index);
        handleAttributeChange(e.target.value, index);
    };
    return (
        <FormControl
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired={validation.Required}
            isInvalid={!!error}
            sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(),
                            paddingTop: 0,
                            whiteSpace: 'normal',
                            overflow: 'visible',
                        }}>
                        {attribute.name}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        <LinkifiedText
                            text={
                                attribute?.description ||
                                'Enter a GUID value for this attribute.'
                            }
                        />
                    </Text>
                </Box>
                <Box style={{ flex: 1, minWidth: '450px' }}>
                    <VStack width="100%" alignItems="normal">
                        <Input
                            id={`attribute-${index}`}
                            name={`attributes[${index}].value`}
                            placeholder="Please enter a value"
                            value={attribute.value ?? ''}
                            onChange={handleChange}
                            sx={{ ...textBoxStyling, paddingTop: 0 }}
                        />
                        <FormErrorMessage
                            display="flex"
                            sx={{ marginTop: '0 !important', fontSize: '10px' }}
                            justifyContent="flex-end">
                            {error ? error.message : ''}
                        </FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={
                            attribute?.description ||
                            'Enter a GUID value for this attribute.'
                        }
                        ariaLabel="vendor-defined-guid-attribute-tip"
                        left="25px"
                        top="10px"
                    />
                )}
            </Stack>
        </FormControl>
    );
}
